<h1 mat-dialog-title>Logout</h1>
<div mat-dialog-content>
  {{ 'are_you_sure' | translate }}
</div>
<div mat-dialog-actions>
  <p>
    <button mat-button (click)="onNoClick()">{{ 'no' | translate }}</button>
    <button mat-raised-button color="primary" (click)="logout()" cdkFocusInitial>{{ 'yes_sure' | translate }}</button>
  </p>
</div>